import React, { useEffect, useState } from 'react';
import { loadGoogleMaps } from "./googleMap/loadGoogleMaps";

const MapWithMarker = ({ location, defaultZoom, sx }) => {
 
  const [map, setMap] = useState(null); // State to store the map instance

  useEffect(() => {
    const initMap = () => {
      const mapInstance = new window.google.maps.Map(document.getElementById("map"), {
        zoom: defaultZoom || 12,
        center: location, 
        mapTypeId: "terrain",
      });

      // Add the marker to the map
      new window.google.maps.Marker({
        position: location,
        map: mapInstance,
      });

      setMap(mapInstance); // Store the map instance in the state
    };

    // shared singleton loader — one SDK load app-wide (avoids the double-load corruption)
    let cancelled = false;
    loadGoogleMaps().then(() => { if (!cancelled) initMap(); }).catch(() => {});
    return () => { cancelled = true; };
  }, [location, defaultZoom]);

  return <div id="map" style={sx}></div>;
};

export default MapWithMarker;
